import { ComponentType } from 'react';
import {
  IconBolt,
  IconChartLine,
  IconReportAnalytics,
  IconQuestionMark,
  IconCalculator,
  IconNews,
  IconDashboard,
  IconFileUpload,
  IconBook,
  IconMathFunction,
  IconUser,
  IconSun,
} from '@tabler/icons-react';

// Icon props type that matches Tabler icons
interface IconProps {
  size?: number;
  className?: string;
  stroke?: number;
}

export interface NavItem {
  id: string;
  label: string;
  path: string;
  icon?: ComponentType<IconProps>;
}

export interface NavSection {
  id: string;
  label: string;
  icon: ComponentType<IconProps>;
  basePath: string;
  items: NavItem[];
  requiresAuth?: boolean;
  showInPrimaryNav?: boolean;
}

/**
 * NAVIGATION_CONFIG
 *
 * Simplified navigation structure:
 * - Primary CTA: "Porównaj taryfy" → /kalkulatory/podstawowy
 * - "Więcej" menu contains: Kalkulatory, Przewodnik, Aktualności
 * - "Moje konto" for authenticated users
 *
 * Note: Secondary nav is removed - all navigation happens through header menus
 */
export const NAVIGATION_CONFIG: NavSection[] = [
  {
    id: 'przewodnik',
    label: 'Przewodnik',
    icon: IconBook,
    basePath: '/przewodnik',
    showInPrimaryNav: false, // Hidden from primary nav, in "Więcej" menu
    items: [
      {
        id: 'taryfy',
        label: 'Porównanie Taryf',
        path: '/przewodnik/taryfy',
        icon: IconBolt,
      },
      {
        id: 'wzorce',
        label: 'Wzorce Zużycia',
        path: '/przewodnik/wzorce',
        icon: IconChartLine,
      },
      {
        id: 'analizy',
        label: 'Analizy',
        path: '/przewodnik/analizy',
        icon: IconReportAnalytics,
      },
      {
        id: 'faq',
        label: 'FAQ',
        path: '/przewodnik/faq',
        icon: IconQuestionMark,
      },
    ],
  },
  {
    id: 'kalkulatory-prosument',
    label: 'Kalkulator Prosumenta',
    icon: IconSun,
    basePath: '/kalkulatory/prosument',
    showInPrimaryNav: false,
    requiresAuth: true,
    items: [],
  },
  {
    id: 'kalkulatory',
    label: 'Kalkulatory',
    icon: IconMathFunction,
    basePath: '/kalkulatory',
    showInPrimaryNav: true, // Main CTA in header
    items: [
      {
        id: 'podstawowy',
        label: 'Podstawowy',
        path: '/kalkulatory/podstawowy',
        icon: IconCalculator,
      },
      {
        id: 'zaawansowany',
        label: 'Zaawansowany',
        path: '/kalkulatory/zaawansowany',
        icon: IconCalculator,
      },
    ],
  },
  {
    id: 'aktualnosci',
    label: 'Aktualności',
    icon: IconNews,
    basePath: '/aktualnosci',
    showInPrimaryNav: false, // In "Więcej" menu
    items: [],
  },
  {
    id: 'konto',
    label: 'Moje konto',
    icon: IconUser,
    basePath: '/konto',
    requiresAuth: true,
    showInPrimaryNav: true,
    items: [
      {
        id: 'panel',
        label: 'Panel Klienta',
        path: '/konto/panel',
        icon: IconDashboard,
      },
      {
        id: 'import',
        label: 'Import Danych',
        path: '/konto/import',
        icon: IconFileUpload,
      },
    ],
  },
];
